import React, { useEffect, useRef, useState } from "react";
import Editor from "../../common/Editor";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useToast from "../../util/useToast";
import useAppContext from "../../useAppContext";
import clsx from "clsx";
import styles from "./WorkersEditor.module.scss";
import Form from "react-bootstrap/esm/Form";
import Button from "../../common/Button";
import { apiUpdateWorkers } from "../../api/ApiParameters";
import { apiGetContext } from "../../api/ApiApp";

const WorkersEditor = ({show, hide, onSubmit}) => {
  const {showToastSuccess} = useToast();

  const {activeWorkers} = useAppContext();

  const queryClient = useQueryClient();

  const inputRefs = useRef([]);

  const [formErrors, setFormErrors] = useState({});

  const [formWorkers, setFormWorkers] = useState([]);

  const editMutation = useMutation(apiUpdateWorkers());

  useEffect(() => {
    if (show) {
      setFormErrors({});

      setFormWorkers(activeWorkers
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(worker => {
          return {id: worker.id, name: worker.name};
        }));

      inputRefs.current = [];
    }
  }, [show, activeWorkers]);

  const submit = () => {
    return editMutation.mutateAsync(formWorkers)
      .then(() => {
        return (onSubmit ? onSubmit() : Promise.resolve()).then(() => {
          showToastSuccess("Liste des ouvriers modifiées");
        });
      })
      .then(() => queryClient.invalidateQueries(apiGetContext().queryKey))
      .then(hide)
      .catch((err) => {
        if (err.response?.status === 400) {
          setFormErrors(err.response.data.errors);
        }
      });
  };

  const addWorker = () => {
    setFormWorkers(prev => ([...prev, {name: ""}]));

    setTimeout(() => {
      inputRefs.current[formWorkers.length].focus();
    }, 10);
  };

  const removeWorker = index => () => {
    setFormWorkers(prev => [...prev.slice(0, index), ...prev.slice(index + 1)]);
  };

  const updateFormData = (field, context = null) => e => {
    setFormWorkers(prev => {
      switch (field) {
        case "name":
          prev[context].name = e.target.value;
          break;
        default:
          prev[context] = e.target.value;
          break;
      }

      return [...prev];
    });
  };

  return <Editor
    show={show}
    title={"Ouvriers"}
    onSubmit={submit}
    onCancel={hide}
    submitLabel="Sauvegarder"
    cancelLabel="Annuler"
  >
    {formWorkers.map((worker, index) => {
      return <div key={worker.id || index} className={clsx(styles.worker)}>
        <div className={styles.input}>
          <Form.Control
            ref={el => inputRefs.current[index] = el}
            type="text"
            value={worker.name}
            onChange={updateFormData("name", index)}
            maxLength="255"
          />
        </div>

        <div className={styles.actions}>
          <span className="material-icons" onClick={removeWorker(index)}>delete</span>
        </div>
      </div>;
    })}

    <Button variant="link" onClick={addWorker}>Ajouter</Button>
  </Editor>;
};

export default WorkersEditor;